import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Cnpj,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import ModalPendenciasTransportadora from './ModalPendenciasTransportadora/ModalPendenciasTransportadora'
import usePendenciasTransportadora, { LOAD_MESSAGE } from './PendenciasTransportadoraHook'

function PendenciasTransportadora({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = usePendenciasTransportadora()

  useEffect(() => {
    localDispatch.onInit()
  }, [])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.FETCH_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPendenciasPorTransportadora(selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <>
      <PageHeader>6.7 - Pendencias por Transportadora</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <DataTable
                value={state.transportadoras}
                paginator={true}
                rows={10}
                header={<CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange} />}
                globalFilter={state.globalFilter}
                emptyMessage={'Sem transportadoras cadastradas'}
                style={state.transportadoras.length === 0 ? { textAlign: 'center' } : {}}
              >
                <Column field="nome" header="Nome" />
                <Column
                  field="cnpj"
                  header="CNPJ"
                  body={(transportadora, column) => <Cnpj>{transportadora.cnpj}</Cnpj>}
                />
                <Column field="city" header="Cidade" />
                <Column field="state" header="Estado" />
                <Column
                  field="actived"
                  header="Ativo"
                  style={{ textAlign: 'center', width: 100 }}
                  body={(rowData, column) => <CustomCheckbox disabled checked={rowData.actived} />}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={transportadora => (
                    <ThreeDots
                      items={['Pendencias', 'Exportar']}
                      onClick={item => localDispatch.onMenuItemClicked(item, transportadora)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalPendenciasTransportadora modal={state.modal} onResponse={localDispatch.onModalEvent} />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })

export default connect(mapStateToProps)(withRouter(PendenciasTransportadora))
